import { IconProps } from "../../utils/global-types/global-types";

const WorkflowIcon = ({ className }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 18 18"
      className={className ? className : "w-5 h-5"}
    >
      <g clipPath="url(#clip0_757_6034)">
        <path
          fill="currentColor"
          fillRule="evenodd"
          d="m6.311 12.35 1.394 1.81a.397.397 0 0 1-.05.537l-.479.435a.39.39 0 0 1-.303.102.39.39 0 0 1-.28-.155l-1.545-2zm7.643-4.647h1.419a.411.411 0 1 0-.002-.822h-1.419a.411.411 0 1 0 .002.822M12.27 3.967l.71-1.229a.412.412 0 0 0-.712-.413l-.71 1.23a.412.412 0 0 0 .712.412m1.642 1.472 1.164-.672a.414.414 0 0 0-.413-.717l-1.165.673a.413.413 0 0 0 .414.716m-1.833 1.85 1.374 2.38a.94.94 0 0 1-.343 1.282.94.94 0 0 1-1.226-.258c-1.52-.231-3.502.018-5.472.785l-1.894-3.28c1.651-1.32 2.86-2.904 3.42-4.336a.94.94 0 0 1 .386-1.2.94.94 0 0 1 1.281.343l1.374 2.38q.06-.046.125-.084a1.11 1.11 0 1 1 .975 1.989m-6.143 4.537L3.952 8.388 2.374 9.3a2.02 2.02 0 0 0-.737 2.75 2.02 2.02 0 0 0 2.75.736l1.577-.91z"
          clipRule="evenodd"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_757_6034">
          <path fill="currentColor" d="M1.076 1.178h15v15h-15z"></path>
        </clipPath>
      </defs>
    </svg>
  );
};

export default WorkflowIcon;
